import React from "react"
import styled from "styled-components"

export const Container = styled.div`
  position: relative;
  display: flex;
  overflow: hidden;
`

export const Content = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  width: 100%;
  height: 100%;
  z-index: 1;
`

const Image = styled.img`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
`

export interface BackgroundImageHelperProps {
  alt?: string
  children?: any
  maxWidth?: string
  quality?: number
  src: string
}

const widths = ["320w", "600w", "800w", "1024w", "1200w", "1440w", "1920w"]

const BackgroundImageHelper: React.FC<BackgroundImageHelperProps> = ({
  alt,
  children,
  maxWidth,
  quality = 50,
  src,
}: BackgroundImageHelperProps) => {
  const srcWidths = maxWidth
    ? [...widths, `${parseFloat(maxWidth)}w`].filter(
        (w) => parseFloat(w) < parseFloat(maxWidth)
      )
    : widths
  const webpSources = srcWidths.map(
    (w) => `${src}?w=${parseFloat(w)}&q=${quality}&fm=webp ${w}`
  )
  const pngSources = srcWidths.map(
    (w) => `${src}?w=${parseFloat(w)}&q=${quality}&fm=webp ${w}`
  )
  const fallbackSources = srcWidths.map(
    (w) => `${src}?w=${parseFloat(w)}&q=${quality} ${w}`
  )

  return (
    <Container>
      <Content>{children}</Content>
      <picture>
        <source srcSet={webpSources.join(", ")} type="image/webp" />
        <source srcSet={pngSources.join(", ")} />
        <Image alt={alt || ""} srcSet={fallbackSources.join(", ")} />
      </picture>
    </Container>
  )
}

export default BackgroundImageHelper
